import { Component, OnInit, OnDestroy } from '@angular/core';
import { DynamicLoaderService } from '../../services/dynamic-loader.service';
import { UsersService } from '../../services/users.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  email: string;

  constructor(
    private readonly dynamicLoaderService: DynamicLoaderService,
    private readonly usersService: UsersService,
  ) { }

  ngOnInit(): void {
    this.dynamicLoaderService.loadCSS('/assets/css/dashforge.auth.css');
    this.dynamicLoaderService.loadCSS('/assets/css/skin.light.css');
  }

  ngOnDestroy(): void {
    this.dynamicLoaderService.removeCSS('/assets/css/dashforge.auth.css');
    this.dynamicLoaderService.removeCSS('/assets/css/skin.light.css');
  }

  async  passwordRecovery(): Promise<void> {
    try {
      const response = await this.usersService.recoverPassword(this.email);
      await Swal.fire('', response.desc, 'success');
      this.email = '';
    } catch (e) {
      Swal.fire('', e.error.desc || 'Error desconocido, intente más tarde', 'error');
    }
  }

}
